import { Component, computed, inject, OnInit } from '@angular/core';

import { BookingStore } from '../../../../pages/booking/store';

import { PassengerType } from '../../../enums';
import { PassengerTypePipe } from '../../../pipes';

@Component({
  selector: 'app-passengers',
  templateUrl: './passengers.component.html',
  imports: [PassengerTypePipe],
})
export class PassengersComponent implements OnInit {
  private _bookingStore = inject(BookingStore);
  readonly PassengerType = PassengerType;
  readonly passengers = computed(() => {
    const passengerInfo = this._bookingStore.passengerInfo();
    return passengerInfo.passengers;
  });

  constructor() {}

  ngOnInit(): void {}
}
